export enum InsertStatus {
	EDIT_LINK_TOOLBAR = 'EDIT',
	INSERT_LINK_TOOLBAR = 'INSERT',
	EDIT_INSERTED_TOOLBAR = 'EDIT_INSERTED',
}
